import { requestGooseAPI, getAPIPath } from '../shared/request'
import { ADMIN_ASSET_USAGES_PATH, ADMIN_ASSET_USAGES_ID_PATH } from '../types/constants'
import { AssetUsageAdminDto, AssetUsageCreateInput, AssetUsageUpdateInput } from '../types/api'

export const AdminAssetUsageService = {
  create: async (locationName: string, assetId: string, data: Partial<AssetUsageCreateInput>) => {
    return requestGooseAPI<AssetUsageAdminDto>({
      url: getAPIPath(ADMIN_ASSET_USAGES_PATH, { locationId: locationName }),
      method: 'POST',
      data: {
        assetId,
        ...data,
      },
    })
  },

  update: async (locationName: string, assetUsageId: string, data: AssetUsageUpdateInput) => {
    return requestGooseAPI<AssetUsageAdminDto>({
      url: getAPIPath(ADMIN_ASSET_USAGES_ID_PATH, { locationId: locationName, id: assetUsageId }),
      method: 'PUT',
      data,
    })
  },

  remove: (locationName: string, assetUsageId: string) =>
    requestGooseAPI<AssetUsageAdminDto>({
      url: getAPIPath(ADMIN_ASSET_USAGES_ID_PATH, { locationId: locationName, id: assetUsageId }),
      method: 'DELETE',
    }),
}
